export default "__VITE_ASSET__DYzu9YlN__"